import HourPicker from "@edusogno/composites/hours";
import { cn } from "@edusogno/lib/utils";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@edusogno/primitives/avatar";
import { ScrollArea } from "@edusogno/primitives/scroll-area.js";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@edusogno/primitives/tabs";
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@edusogno/primitives/toggle-group";
import React from "react";
import { AllTutorsHourObj } from "@/pages/OneToOne";
import useOneToOne, { TutorInfo } from "@/utils/hooks/useOneToOne";
import { useTranslation } from "react-i18next";

type OneToOneHourSelectProps = {
  onValueChange: (
    time: string | string[],
    previousTutor: string,
    isPreviousTutor?: boolean,
  ) => void;
  value: string;
  className?: string;
  isPreviousTutor: boolean;
  hours?: string[];
  openHours?: string[];
  previousTutorInfo: { name: string; image: string; token: string };
  allList: AllTutorsHourObj[];
  // allList?: [
  //   {
  //     hour: string;
  //     tutorsAvailable?: [{ name?: string; image?: string }];
  //   },
  // ];
};

const OneToOneHourSelect: React.FC<OneToOneHourSelectProps> = ({
  className,
  onValueChange,
  isPreviousTutor,
  value,
  hours,
  openHours,
  previousTutorInfo,
  allList,
  // previousTutorInfo = {
  //   name: "Shakira",
  //   image: tutorpic,
  // },
  // allList = [
  // {
  //   hour: "13:00",
  //   tutorsAvailable: [
  //     {
  //       name: "Shakira",
  //       image: tutorpic,
  //     },
  //     {
  //       name: "Shakira",
  //       image: tutorpic,
  //     },
  //     {
  //       name: "Shakira",
  //       image: tutorpic,
  //     },
  //     {
  //       name: "Shakira",
  //       image: tutorpic,
  //     },
  //   ],
  // },
  // {
  //   hour: "19:00",
  //   tutorsAvailable: [
  //     {
  //       name: "Shakira",
  //       image: tutorpic,
  //     },
  //     {
  //       name: "Shakira",
  //       image: tutorpic,
  //     },
  //     {
  //       name: "Shakira",
  //       image: tutorpic,
  //     },
  //     {
  //       name: "Shakira",
  //       image: tutorpic,
  //     },
  //   ],
  // },
  // ],
}) => {
  const { setState } = useOneToOne();
  const { t } = useTranslation();
  // const  [isPreviousTutor, previousTutorTimeSlot] = useState()
  return (
    <div
      className={cn(
        "w-full h-full flex-[1_1_0] flex-col lg:min-h-[20%] max-w-[600px] max-h-[600px] flex",
        className,
      )}
    >
      <Tabs
        defaultValue={isPreviousTutor ? "previous-tutor" : "all"}
        className=" h-full w-full flex flex-col"
      >
        <div className="flex flex-row items-center justify-center gap-2  w-full">
          <TabsList
            className={"p-0 rounded-[7px] h-9 w-full !bg-[--grey200]  "}
          >
            <TabsTrigger
              className={
                "active:border-none active:outline-0 w-1/2 data-[state=active]:bg-brand-deep h-9 text-brand-deep  text-sm px-1 md:px-2 rounded-[7px] data-[state=active]:text-white"
              }
              value="all"
            >
              {t("labels.all")}
            </TabsTrigger>
            <TabsTrigger
              className={
                "active:border-none px-1  active:outline-0 w-1/2 data-[state=active]:bg-brand-deep  text-brand-deep h-9  !text-sm  md:px-2 rounded-[7px] data-[state=active]:text-white"
              }
              value="previous-tutor"
            >
              <div
                className={"grid grid-cols-[28px_auto] items-center   gap-2"}
              >
                <Avatar className={"w-[28px] h-[28px]"}>
                  <AvatarImage src={previousTutorInfo.image} />
                  <AvatarFallback>
                    {previousTutorInfo.name.charAt(0)}
                  </AvatarFallback>
                </Avatar>
                <div className={"flex flex-col text-start"}>
                  <p className={"text-sm "}>{previousTutorInfo.name}</p>
                  <p className={"text-[6px] lg:text-[10px] leading-[100%]"}>
                    {t("one_to_one.your_last_tutor")}
                  </p>
                </div>
              </div>
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent
          value="all"
          className={"h-[calc(100%_-_38px)] mt-0 pt-3 lg:pt-8"}
        >
          <ScrollArea className="h-full">
            <ToggleGroup
              value={isPreviousTutor ? undefined : value}
              // onValueChange={(v) => onValueChange(v, false)}
              onValueChange={(v) =>
                onValueChange(v, previousTutorInfo.token, false)
              }
              type={"single"}
              className={"flex flex-col w-full"}
            >
              {/* {allList.map((r) => ( */}
              {allList.map((r, index) => (
                <ToggleGroupItem
                  key={index}
                  className={
                    "flex flex-row justify-between text-brand px-6 w-full data-[state=on]:bg-primary data-[state=on]:text-white bg-[--grey200]"
                  }
                  value={r.hour}
                >
                  <p className={"text-sm font-bold"}>{r.hour}</p>
                  <div className={"flex flex-row items-center gap-2"}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="9"
                      height="7"
                      viewBox="0 0 9 7"
                      fill="none"
                    >
                      <path
                        d="M1 3.5L3.33333 6L8 1"
                        stroke="#219653"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <p className={"text-xs"}>
                      {r?.tutorsAvailable?.length}{" "}
                      {r?.tutorsAvailable?.length > 1
                        ? t("one_to_one.free_tutors")
                        : t("one_to_one.free_tutor")}
                    </p>
                    <div
                      className={"flex flex-row items-center relative w-[60px]"}
                    >
                      {r?.tutorsAvailable?.slice(0, 3)?.map((l, idx, arr) => {
                        const scale = Math.max(1 - idx / arr.length, 0.4);
                        return (
                          <Avatar
                            key={l.name + "_" + idx}
                            style={{
                              width: 28 * scale, // do not do this
                              height: 28 * scale,
                              zIndex: Math.ceil(10 * scale),
                              position: "absolute",
                              right: 8 * (1 - idx),
                            }}
                          >
                            <AvatarImage src={l.image} />
                            {/* <AvatarFallback>SK</AvatarFallback> */}
                            <AvatarFallback>{l.name.charAt(0)}</AvatarFallback>
                          </Avatar>
                        );
                      })}
                    </div>
                  </div>
                </ToggleGroupItem>
              ))}
            </ToggleGroup>
          </ScrollArea>
        </TabsContent>
        <TabsContent
          value="previous-tutor"
          className={
            "h-[calc(100%_-_36px)] min-w-0 flex-[1_1_0] mt-0 pt-3 lg:pt-8"
          }
        >
          {hours?.length == 0 && (
            <p className="text-red-500 font-bold">
              {t("one_to_one.error_previous_tutor")}
            </p>
          )}
          <HourPicker
            openHours={openHours}
            hours={hours}
            type={"single"}
            value={isPreviousTutor ? value : undefined}
            onValueChange={(v) => {
              onValueChange(v, previousTutorInfo.token, true);
              setState("tutorSelected", {
                name: previousTutorInfo.name,
                image: previousTutorInfo.image,
                token: previousTutorInfo.token,
              } as TutorInfo);
            }}
            className="max-w-full !p-0"
            // className={
            //   "[&_button]:flex-[1_1_129px] [&_button]:h-[35px] auto-rows-[35px] !px-0 h-full"
            // }
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};
export default OneToOneHourSelect;
